module.exports = __webpack_public_path__ + "static/media/0110_LE_SOL_66_PELER.2e31f841.webp";